/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Timeline_Select_Prev_EventInputs */

const en_shortcut_keys_desc_timeline_select_prev_event = /** @type {(inputs: Shortcut_Keys_Desc_Timeline_Select_Prev_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selects the previous event closest to the current player time`)
};

const fr_shortcut_keys_desc_timeline_select_prev_event = /** @type {(inputs: Shortcut_Keys_Desc_Timeline_Select_Prev_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selectionner l'evenement precedent le plus proche du temps de lecture`)
};

const de_shortcut_keys_desc_timeline_select_prev_event = /** @type {(inputs: Shortcut_Keys_Desc_Timeline_Select_Prev_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählt das vorherige Ereignis aus, das dem aktuellen Spielerzeitpunkt am nächsten liegt.`)
};

const it_shortcut_keys_desc_timeline_select_prev_event = /** @type {(inputs: Shortcut_Keys_Desc_Timeline_Select_Prev_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona l'evento precedente più vicino all'orario attuale del giocatore`)
};

const ru_shortcut_keys_desc_timeline_select_prev_event = /** @type {(inputs: Shortcut_Keys_Desc_Timeline_Select_Prev_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выбирает предыдущее событие, наиболее близкое к текущему времени игрока.`)
};

const es_shortcut_keys_desc_timeline_select_prev_event = /** @type {(inputs: Shortcut_Keys_Desc_Timeline_Select_Prev_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecciona el evento anterior más cercano al tiempo del jugador actual`)
};

const zh_cn2_shortcut_keys_desc_timeline_select_prev_event = /** @type {(inputs: Shortcut_Keys_Desc_Timeline_Select_Prev_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择距离当前玩家时间最近的上一次事件`)
};

const ja_shortcut_keys_desc_timeline_select_prev_event = /** @type {(inputs: Shortcut_Keys_Desc_Timeline_Select_Prev_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現在のプレイヤー時間に最も近い前のイベントを選択します`)
};

const hi_shortcut_keys_desc_timeline_select_prev_event = /** @type {(inputs: Shortcut_Keys_Desc_Timeline_Select_Prev_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वर्तमान खिलाड़ी के समय के सबसे निकट की पिछली घटना का चयन करता है`)
};

const pt_pt2_shortcut_keys_desc_timeline_select_prev_event = /** @type {(inputs: Shortcut_Keys_Desc_Timeline_Select_Prev_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleciona o evento anterior mais próximo do tempo atual do jogador.`)
};

/**
* | output |
* | --- |
* | "Selects the previous event closest to the current player time" |
*
* @param {Shortcut_Keys_Desc_Timeline_Select_Prev_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_timeline_select_prev_event = /** @type {((inputs?: Shortcut_Keys_Desc_Timeline_Select_Prev_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Timeline_Select_Prev_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_timeline_select_prev_event(inputs)
	if (locale === "de") return de_shortcut_keys_desc_timeline_select_prev_event(inputs)
	if (locale === "it") return it_shortcut_keys_desc_timeline_select_prev_event(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_timeline_select_prev_event(inputs)
	if (locale === "es") return es_shortcut_keys_desc_timeline_select_prev_event(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_timeline_select_prev_event(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_timeline_select_prev_event(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_timeline_select_prev_event(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_timeline_select_prev_event(inputs)
	return en_shortcut_keys_desc_timeline_select_prev_event(inputs)
});